import { Member, MemberModel } from "./Member.ts";


export interface NotificationModel {
  id?: string
  createdAt?: Date
  text?: string
  isRead?: boolean
  user?: MemberModel
}


export class Notification implements NotificationModel {
  id?: string
  createdAt?: Date
  text?: string
  isRead?: boolean
  user?: MemberModel

  constructor(
    id = undefined,
    createdAt = undefined,
    text = undefined,
    isRead = undefined,
    user?: MemberModel
  ) {
    this.id = id
    this.createdAt = createdAt
    this.text = text
    this.isRead = isRead
    this.user = user
  }

  static convertFromParseObject(parseObject: any): NotificationModel {
    let user = parseObject?.get("user")

    let userObject = user === undefined ? undefined : Member.convertFromParseObject(user)
    let isRead = userObject === undefined ? true : parseObject?.get("isRead")

    return new Notification(
      parseObject.id,
      parseObject.createdAt,
      parseObject.get("text"),
      isRead,
      userObject
    )
  }
}
